import React from "react";

const NailExtensionInLavelleAfford = () => {
  return (
    <div className="HairSalonInSahakaraHead">
      <h3>Affordable Nail Extensions Near Lavelle Road</h3>
      <p>
        SCENT Salon offers nail extensions near Lavelle Road at competitive
        prices, allowing you to enjoy top-tier services without breaking the
        bank. Our range of services and customizable packages make it easy to
        find the perfect fit for your style and budget, whether you want a quick
        touch-up or a full set of extensions.
      </p>
    </div>
  );
};

export default NailExtensionInLavelleAfford;
